'use client';
import Product from '@models/product';
import YoutubeCard from '@components/shared/YoutubeCard';
import ProductCard from '@components/Cards/ProductCard';
import LearnCard from '@repo/ui/src/components/Cards/LearnCard';
import RecipeCard from '@repo/ui/src/components/Cards/RecipeCard';
import RecipeCardSimple from '@repo/ui/src/components/Cards/RecipeCardSimple';
import PressArticle from '@repo/ui/src/components/Cards/PressArticle';
import AuthorCard from '@repo/ui/src/components/Cards/AuthorCard';
import WoodPelletFlavor from '@components/WoodPelletFlavors/_WoodPelletFlavor';

interface Props {
  item: any;
  schema?: string;
  isCarousel?: boolean;
  saleText?: string;
  outOfStockText?: string;
  newText?: string;
  small?: boolean;
  darkMode?: boolean;
}

const CarouselItem = ({
  item,
  schema = item._meta?.schema,
  isCarousel,
  saleText,
  outOfStockText,
  newText,
  small,
  darkMode,
}: Props) => {
  switch (schema) {
    case 'https://traegergrills.com/data/contentTypes/traegerTV.json':
      return <YoutubeCard {...item} darkMode={darkMode} />;
    case 'https://traegergrills.com/data/contentTypes/youtubeVideo.json':
      return <YoutubeCard {...item} darkMode={darkMode} />;
    case 'https://traegergrills.com/data/contentTypes/pressArticle.json':
      return <PressArticle {...item} />;
    case 'https://traegergrills.com/data/contentTypes/learn.json':
      return <LearnCard {...item} />;
    case 'https://traegergrills.com/data/contentTypes/author.json':
      return <AuthorCard {...item} />;
    case 'https://traegergrills.com/data/contentTypes/recipe.json':
      return <RecipeCard {...item} />;
    case 'https://traegergrills.com/data/contentTypes/recipeSimple.json':
      return <RecipeCardSimple {...item} />;
    case 'https://traegergrills.com/data/contentTypes/woodPelletFlavor.json':
      return <WoodPelletFlavor {...item} />;
    case 'https://traegergrills.com/data/contentTypes/product.json':
    default:
      return (
        <ProductCard
          product={item instanceof Product ? item : new Product(item)}
          isCarousel={isCarousel}
          saleText={saleText}
          outOfStockText={outOfStockText}
          newText={newText}
          small={small}
        />
      );
  }
};

export default CarouselItem;
